import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';

export class FascicoloMobiliare extends FascicoloFull {
  sezione: string;
  numRuoloDecretoRif: string;
  posizioneFascicoloRif: string;
  dataInizioFascicoloRif: number;
  valorePrecettoDiRiferimento: number | string;

  dataConsegnaAlCreditore: number;
  dataPignoramento: number;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }





}
